/**
 * The default for an empty value or property name
 * is ' ' and is NOT a valid property for enabled workflows. We do this so we can tell the difference
 * between a clear property (value of '') and this new empty property (value of ' ') in
 * `inferPropertyActionOperationType` without changing all existing actions.
 */
export const DEFAULT_EMPTY_PROPERTY_NAME_OR_VALUE = ' ';
export const isDefaultEmptyPropertyValue = value => value === DEFAULT_EMPTY_PROPERTY_NAME_OR_VALUE;